import ConversationItemParts from './schema/ConversationItemParts';
import { MruCache } from 'owa-mru-cache';

const CACHE_SIZE = 12;

/**
 * Create a MRU cache to store conversation data
 */
const conversationCache = new MruCache<ConversationItemParts>(CACHE_SIZE);
export default conversationCache;
